// extracted by mini-css-extract-plugin
export default {"side-nav":"SideNav_side-nav__8G3WR"};